import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkPay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 11,
	viewBox: "0 0 32 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5149_3326)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1319 1.64352C16.1319 1.13884 16.5562 0.732422 17.0564 0.732422C17.5566 0.732422 17.9809 1.14331 17.9809 1.64352C17.9809 2.14373 17.57 2.56801 17.0564 2.56801C16.5428 2.56801 16.1319 2.15713 16.1319 1.64352ZM13.3896 0.857474H14.9975V9.86124H13.3896V0.857474ZM17.8692 3.42998H16.248V9.86124H17.8692V3.42998ZM29.5214 6.42677C30.7407 5.67646 31.5714 4.55992 31.8974 3.42551H30.2762C29.8519 4.50632 28.8827 5.31916 27.8198 5.66306V0.857474H26.1986V9.86124H27.8198V7.18155C29.0569 7.48971 30.035 8.56159 30.37 9.86124H32.0001C31.75 8.49907 30.8211 7.22175 29.5214 6.43124V6.42677ZM20.7409 4.14903C21.1652 3.5863 21.9915 3.2558 22.6659 3.2558C23.9164 3.2558 24.9525 4.17136 24.957 5.55587V9.85678H23.3358V5.91316C23.3358 5.34596 23.0812 4.68944 22.2639 4.68944C21.2992 4.68944 20.7454 5.54694 20.7454 6.54736V9.86571H19.1242V3.43445H20.7454V4.14903H20.7409Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.35939 10.7188C8.32045 10.7188 10.7188 8.32045 10.7188 5.35939C10.7188 2.39833 8.32045 0 5.35939 0C2.39833 0 0 2.39833 0 5.35939C0 8.32045 2.39833 10.7188 5.35939 10.7188Z",
				fill: "#00D66F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.1139 2.1438H3.46143C3.78299 3.48811 4.72088 4.63591 5.89548 5.35943C4.71642 6.08295 3.78299 7.23075 3.46143 8.57506H5.1139C5.52479 7.33347 6.65919 6.25266 8.05263 6.02935V4.68504C6.65919 4.4662 5.52479 3.38539 5.1139 2.1438Z",
				fill: "#011E0F"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5149_3326",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 10.7188,
			fill: "white"
		})
	}) })]
});
export default SvgLinkPay;
